import Reveal from "@/components/base/Reveal";
import { useSiteImage, useSiteImageAlt, useSiteText } from "@/lib/siteContent";

const pillars = [
  { value: "Versatilidade", label: "escolhas para diferentes momentos" },
  { value: "Cuidado", label: "atenção aos materiais e acabamentos" },
  { value: "Proximidade", label: "atendimento humano pelo WhatsApp" },
];

export default function BrandStory() {
  const eyebrow = useSiteText("brandStory.eyebrow", "Nossa essência");
  const title = useSiteText("brandStory.title", "Estilo, conforto e personalidade em cada escolha");
  const image = useSiteImage(
    "brandStory.image",
    "https://readdy.ai/api/search-image?query=Editorial%20behind%20the%20scenes%20photo%20of%20a%20warm%20contemporary%20Brazilian%20atelier%20shelf%20neatly%20organized%20with%20different%20womens%20leather%20shoes%2C%20sandals%20and%20bags%20in%20caramel%2C%20ivory%20and%20bordeaux%20tones%2C%20a%20hand%20carefully%20arranging%20a%20sandal%2C%20neutral%20shoe%20boxes%20without%20branding%2C%20a%20leather%20belt%20detail%2C%20natural%20daylight%2C%20realistic%20material%20textures%2C%20no%20text%2C%20no%20logos%2C%20no%20watermark&width=900&height=1100&seq=aur-historia-bastidores-01&orientation=portrait&nocache=true",
  );
  const imageAlt = useSiteImageAlt(
    "brandStory.image",
    "Prateleira de ateliê com calçados, bolsas e cintos de couro organizados",
  );
  return (
    <section className="w-full bg-background-100" aria-label="Nossa essência Auréa">
      <div className="px-4 py-16 md:px-8 md:py-24">
        <div className="mx-auto grid max-w-6xl grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-14">
          <Reveal className="order-2 lg:order-1">
            <span className="flex items-center gap-2 text-[11px] uppercase tracking-[0.28em] text-accent-700">
              <span className="flex h-3 w-3 items-center justify-center">
                <span className="h-1.5 w-1.5 rounded-full bg-secondary-500" />
              </span>
              {eyebrow}
            </span>
            <h2 className="mt-4 font-heading text-3xl font-medium leading-tight text-foreground-900 md:text-4xl">
              {title}
            </h2>
            <p className="mt-5 text-sm leading-relaxed text-foreground-600 md:text-base">
              A Auréa nasce como uma marca demonstrativa pensada para mulheres que vivem diferentes
              rotinas, ocasiões e versões de si mesmas. Uma seleção feminina e versátil de calçados e
              acessórios para completar o look com leveza, presença e autenticidade.
            </p>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              Cada produto é escolhido pensando em quem quer se sentir bem nos próprios passos, do começo
              da manhã até o fim do dia.
            </p>

            <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-3">
              {pillars.map((stat) => (
                <div key={stat.value} className="rounded-lg border border-background-200 bg-background-50 p-4">
                  <p className="font-heading text-xl text-primary-700">{stat.value}</p>
                  <p className="mt-1 text-[11px] leading-snug text-foreground-600">{stat.label}</p>
                </div>
              ))}
            </div>
          </Reveal>

          <Reveal delay={120} className="order-1 lg:order-2">
            <div className="relative h-[360px] w-full overflow-hidden rounded-lg bg-background-200 md:h-[500px]">
              <img
                src={image}
                alt={imageAlt}
                title="Bastidores Auréa — organização de calçados e acessórios"
                loading="lazy"
                className="h-full w-full object-cover object-top"
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}